import { ViewSupport42Component } from "../../../components/SupportSystem/ViewReports/ViewSupport42Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport42Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport42Component";
export function ViewSupport42Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-2)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport42Component />
            <Footer />
        </div>
    );
}
